module.exports = __webpack_public_path__ + "static/img/yooc.34727e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/content/yooc.png
// module id = rYi6
// module chunks = 1